// @flow
import React from 'react';
import MarkDown from 'brastrap/editorial/markdown/Markdown';
import ButtonLink from 'brastrap/common/button-link/ButtonLink';
import Link from 'brastrap/containers/link/LinkContainer';
import type { Channel as Props } from './channel.types.js';

const Channel = (props: Props) => {
  const mainAction = props.actions && props.actions.length && props.actions[0];
  const hasDummyButton = !!mainAction;

  const channel = (
    <section className="c-channel">
      <header className="c-channel__header">
        {props.img && props.img.src && (
          <img
            className="c-channel__img"
            src={props.img.src}
            alt={props.img.alt}
            height="48"
          />
        )}
        {props.title && <h2 className="c-channel__title">{props.title}</h2>}
        <div className="c-channel__desc">
          {props.introduction && <MarkDown content={props.introduction} />}
        </div>
      </header>
      {props.actions.length && (
        <div className="c-channel__actions">
          {props.actions.map((action, key) => (
            <ButtonLink
              isDummyButton={hasDummyButton}
              modifiers={['filled', 'small']}
              key={key}
              {...action}
            />
          ))}
        </div>
      )}
    </section>
  );

  return mainAction && mainAction.link ? (
    <Link {...mainAction.link} href={mainAction.link.url}>
      {channel}
    </Link>
  ) : (
    channel
  );
};

Channel.defaultProps = {
  actions: [],
};

export default Channel;
